export enum OnboardingSiteType {
  Provision = "provision",
  Create = "create",
  DeployNow = "deployNow",
  DeployNowProvision = "deployNowProvision",
}
